/** 업데이트 소식 문구 — ko/landingReleases.ts 와 같은 키(정본은 ko). */
const landingReleases = {
  "eyebrow": "アップデート情報",
  "title": "さらに新しくなったドローンスクエア",
  "lead": "最先端の現場技術を、ドローンスクエアでいち早くご体験ください。",
  "demo": "デモ動画を見る",
  "demoLabel": "デモ動画を見る — {{topic}}",
  "demoStepLabel": "デモ動画を見る — {{topic}}、ステップ{{step}}から",
  "artLabel": "{{title}}のイメージ図",
  "items": {
    "auto_mapping": {
      "title": "GCP自動認識",
      "description": "標準マーカーを自ら見つけ、基準点作業なしで地図が完成します。"
    },
    "equip_sim": {
      "title": "機材動線シミュレーション",
      "description": "複数の機材を実寸で動かしてみて、衝突の危険を事前に見つけます。"
    },
    "linear_ew": {
      "title": "線形基準の土工",
      "description": "線形ひとつで測点ごとの切土・盛土量が計算されます。"
    },
    "ew_summary": {
      "title": "3D土工量計算",
      "description": "図面と3Dを比べ、計画・出来高・残りの数量を自動で算出します。"
    },
    "folders": {
      "title": "すべてのデータをフォルダ管理",
      "description": "資料がどれだけ多くても、フォルダにまとめてすぐ見つかります。"
    },
    "walk_roadview": {
      "title": "360°ロードビュー",
      "description": "事務所にいながら、360°写真で現場を歩くように見回せます。"
    },
    "history": {
      "title": "プロジェクト履歴",
      "description": "作成・修正・削除の履歴が時系列で残り、すぐに追跡できます。"
    },
    "area_capture": {
      "title": "範囲キャプチャ",
      "description": "必要な範囲だけを高解像度の画像ですぐに保存します。"
    },
    "issue_comments": {
      "title": "課題コメント",
      "description": "コメントと現場写真で、現場と事務所が同じ課題を共有します。"
    },
    "pano360": {
      "title": "360°写真・動画ビューア",
      "description": "360°写真と動画で現場を四方八方から見回せます。"
    },
    "clip_box": {
      "title": "3D切断面ツール",
      "description": "3Dモデルを切って、隠れた内部まで測定・記録します。"
    },
    "dsm_color": {
      "title": "3D標高カラー",
      "description": "高さごとの色で、3D地形の高低がひと目で分かります。"
    },
    "vectors": {
      "title": "座標入力の3Dベクター",
      "description": "設計座標に沿って、3Dの線形が現場の上にそのまま描かれます。"
    },
    "workers": {
      "title": "作業員の位置管制",
      "description": "作業員の位置をリアルタイムで確認し、立入禁止区域への進入をすぐ知らせます。"
    },
    "first_person": {
      "title": "一人称飛行視点",
      "description": "3D現場の中を自在に飛び回り、隅々まで確認します。"
    },
    "geolog_map": {
      "title": "ジオログ",
      "description": "写真と動画が撮影した場所のまま地図の上に置かれます。"
    },
    "ja": {
      "title": "日本語・クメール語に対応",
      "description": "4か国語と現地のタイムゾーンに対応し、海外現場も同じ画面で管理できます。"
    },
    "dxf_on_3d": {
      "title": "3D図面オーバーレイ",
      "description": "設計図面を3D地形に重ね、設計と現場を立体的に比べます。"
    },
    "profile_3d": {
      "title": "3D縦断・横断面グラフ",
      "description": "線形に沿って3Dモデルの縦断・横断面をすぐに確認できます。"
    }
  }
} as const;

export default landingReleases;
